/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { UserIndexQueryParams, UserIndexResponse } from '../types/UserIndex'

/**
 * GET /users
 * @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::index
 */
export async function userIndex(
	params?: UserIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<UserIndexResponse>> {
	return axiosInstance.get('/users', { params, ...config })
}
